// extracted by mini-css-extract-plugin
module.exports = {"settingsBlock":"styles_settingsBlock__28QxD"};